import { ViewModel } from "mvc-kit";
// src/modules/AppWrapper2/viewmodels/ConnectivityViewModel.ts
/**
* Browser online/offline state.
*
* This lives in its own ViewModel rather than on AppShellViewModel on purpose:
* `useSingleton` re-renders every subscriber on any set() to a ViewModel (there
* is no per-field selector). AppShellViewModel is subscribed to by
* useAppInteractionHandlers(), which every RecordCard/LocationCard/UserCard/
* EventCard/ReportCard/ActivityFeed row calls — so parking `isOnline` there
* would re-render every mounted card in a 200-row list on each network toggle,
* for no visual change.
*/
var ConnectivityViewModel = class extends ViewModel {
	static DEFAULT_STATE = { isOnline: true };
	onInit() {
		this.set({ isOnline: window.navigator.onLine });
		const handleOnline = () => this.set({ isOnline: true });
		const handleOffline = () => this.set({ isOnline: false });
		window.addEventListener("online", handleOnline);
		window.addEventListener("offline", handleOffline);
		this.addCleanup(() => {
			window.removeEventListener("online", handleOnline);
			window.removeEventListener("offline", handleOffline);
		});
	}
	onSet(prev, next) {
		if (prev.isOnline === next.isOnline) return;
		if (next.isOnline) this.emit("wentOnline", void 0);
		else this.emit("wentOffline", void 0);
	}
};
export { ConnectivityViewModel };

//# sourceMappingURL=ConnectivityViewModel.js.map